export function deferTask(task, timeout = 2000)
{
    if (typeof window === 'undefined') return;

    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(function () {
            task();
        }, {timeout: timeout});
        return;
    }

    setTimeout(function () {
        task();
    }, 1);
}
